import { getHostApis } from './getHost'

export function hasTenantHostApi() {
  const host = getHostApis()
  const tenants: Array<keyof typeof host> = ['shift', 'onelaunch']

  return tenants.some((tenant) => host[tenant] !== undefined)
}
